import { useEffect, type RefObject } from "react";

// Колко кадъра се изчаква съдържанието на модала (порталът на antd го закача
// в отделен рендер след своя ефект) — след толкова се отказваме тихо.
const MAX_FRAMES = 30;

/**
 * При отваряне на модал фокусът отива на `ref` (безопасния бутон
 * „Назад"/„Отказ" или първото поле на формата). `autoFocus` не издържа
 * вътре в antd Modal: при отварянето елементът е в портал, който още не е
 * закачен към document (focus() не прави нищо), а antd после фокусира своя
 * диалог. Затова се опитва кадър по кадър, докато елементът наистина вземе
 * фокуса. Фокус вътре в модала antd после не пипа (`focusDialogContent`
 * гледа `activeElement`).
 */
export const useFocusOnOpen = (open: boolean, ref: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    if (!open) return;
    let frame = 0;
    let handle = 0;
    const tryFocus = () => {
      const element = ref.current;
      if (element?.isConnected) {
        element.focus();
        if (document.activeElement === element) return;
      }
      frame += 1;
      if (frame < MAX_FRAMES) handle = window.requestAnimationFrame(tryFocus);
    };
    tryFocus();
    return () => window.cancelAnimationFrame(handle);
  }, [open, ref]);
};
